var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cipher-config" },
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          staticClass: "form-container",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "120px" },
        },
        [
          _c("div", { staticClass: "form-layout" }, [
            _c("div", { staticClass: "form-col form-col-main" }, [
              _c("div", { staticClass: "section-card" }, [
                _c("div", { staticClass: "section-card-header" }, [
                  _vm._v("\n            基本信息\n          "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "section-card-body" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "活动名称", prop: "title" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请输入活动名称" },
                          model: {
                            value: _vm.form.title,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "title", $$v)
                            },
                            expression: "form.title",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "活动副标题", prop: "title2" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "textarea",
                            rows: 3,
                            placeholder: "请输入活动副标题",
                          },
                          model: {
                            value: _vm.form.title2,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "title2", $$v)
                            },
                            expression: "form.title2",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "背景图", prop: "bgUrl" } },
                      [
                        _c("image-upload", {
                          model: {
                            value: _vm.form.bgUrl,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "bgUrl", $$v)
                            },
                            expression: "form.bgUrl",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "封面图中部", prop: "imgUrl" } },
                      [
                        _c("image-upload", {
                          model: {
                            value: _vm.form.imgUrl,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "imgUrl", $$v)
                            },
                            expression: "form.imgUrl",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "封面图底部", prop: "imgUrl2" } },
                      [
                        _c("image-upload", {
                          model: {
                            value: _vm.form.imgUrl2,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "imgUrl2", $$v)
                            },
                            expression: "form.imgUrl2",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "活动规则", prop: "rule" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "textarea",
                            rows: 6,
                            placeholder: "请输入活动规则",
                          },
                          model: {
                            value: _vm.form.rule,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "rule", $$v)
                            },
                            expression: "form.rule",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "是否启用", prop: "isEnable" } },
                      [
                        _c("el-switch", {
                          attrs: {
                            "active-value": 1,
                            "inactive-value": 0,
                            "active-text": "启用",
                            "inactive-text": "禁用",
                          },
                          model: {
                            value: _vm.form.isEnable,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "isEnable", $$v)
                            },
                            expression: "form.isEnable",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "section-card" }, [
                _c("div", { staticClass: "section-card-header" }, [
                  _vm._v("\n            时间设置\n          "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "section-card-body" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "活动时间", prop: "timeRange" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "datetimerange",
                            "range-separator": "至",
                            "start-placeholder": "开始时间",
                            "end-placeholder": "结束时间",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                          },
                          model: {
                            value: _vm.timeRange,
                            callback: function ($$v) {
                              _vm.timeRange = $$v
                            },
                            expression: "timeRange",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "每日时段" } },
                      [
                        _c("el-time-picker", {
                          staticStyle: { width: "160px" },
                          attrs: {
                            placeholder: "开始时间(空=不限)",
                            "value-format": "HH:mm",
                            format: "HH:mm",
                          },
                          model: {
                            value: _vm.form.dayStartTime,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "dayStartTime", $$v)
                            },
                            expression: "form.dayStartTime",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticStyle: { margin: "0 8px" } }, [
                          _vm._v("至"),
                        ]),
                        _vm._v(" "),
                        _c("el-time-picker", {
                          staticStyle: { width: "160px" },
                          attrs: {
                            placeholder: "结束时间(空=不限)",
                            "value-format": "HH:mm",
                            format: "HH:mm",
                          },
                          model: {
                            value: _vm.form.dayEndTime,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "dayEndTime", $$v)
                            },
                            expression: "form.dayEndTime",
                          },
                        }),
                        _vm._v(" "),
                        _vm.crossDay
                          ? _c("div", { staticClass: "form-warn" }, [
                              _vm._v(
                                "\n                每日时段跨零点，请确认是否符合预期\n              "
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "section-card" }, [
                _c("div", { staticClass: "section-card-header" }, [
                  _vm._v("\n            奖励配置\n          "),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "section-card-body" }, [
                  _c(
                    "div",
                    { staticClass: "reward-block" },
                    [
                      _c("div", { staticClass: "reward-block-title" }, [
                        _vm._v("\n                猜对奖励\n                "),
                        _c("span", { staticClass: "reward-block-hint" }, [
                          _vm._v("（猜对口令后发放的优惠券，可配置多张）"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.rewardItems, function (item, index) {
                        return _c(
                          "div",
                          { key: "ok-" + index, staticClass: "reward-row" },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "320px" },
                                attrs: {
                                  placeholder: "请选择优惠券",
                                  filterable: "",
                                  clearable: "",
                                  size: "small",
                                },
                                model: {
                                  value: item.typeId,
                                  callback: function ($$v) {
                                    _vm.$set(item, "typeId", $$v)
                                  },
                                  expression: "item.typeId",
                                },
                              },
                              _vm._l(_vm.bonusList, function (bonus) {
                                return _c("el-option", {
                                  key: bonus.typeId,
                                  attrs: {
                                    label:
                                      "[" +
                                      bonus.typeId +
                                      "] " +
                                      bonus.typeName,
                                    value: bonus.typeId,
                                  },
                                })
                              }),
                              1
                            ),
                            _vm._v(" "),
                            _c("el-input-number", {
                              staticStyle: {
                                "margin-left": "10px",
                                width: "130px",
                              },
                              attrs: { min: 1, size: "small" },
                              model: {
                                value: item.num,
                                callback: function ($$v) {
                                  _vm.$set(item, "num", $$v)
                                },
                                expression: "item.num",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "reward-num-label" }, [
                              _vm._v("张"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                staticStyle: {
                                  color: "#F56C6C",
                                  "margin-left": "10px",
                                },
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeRewardItem(
                                      _vm.rewardItems,
                                      index
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                  删除\n                "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text", icon: "el-icon-plus" },
                          on: {
                            click: function ($event) {
                              return _vm.addRewardItem(_vm.rewardItems)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                添加猜对奖励\n              "
                          ),
                        ]
                      ),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "reward-block" },
                    [
                      _c("div", { staticClass: "reward-block-title" }, [
                        _vm._v("\n                猜错奖励\n                "),
                        _c("span", { staticClass: "reward-block-hint" }, [
                          _vm._v(
                            "（猜错后的安慰奖励，可配置多张，不配置则猜错不发券）"
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.rewardErrorItems, function (item, index) {
                        return _c(
                          "div",
                          { key: "err-" + index, staticClass: "reward-row" },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "320px" },
                                attrs: {
                                  placeholder: "请选择优惠券",
                                  filterable: "",
                                  clearable: "",
                                  size: "small",
                                },
                                model: {
                                  value: item.typeId,
                                  callback: function ($$v) {
                                    _vm.$set(item, "typeId", $$v)
                                  },
                                  expression: "item.typeId",
                                },
                              },
                              _vm._l(_vm.bonusList, function (bonus) {
                                return _c("el-option", {
                                  key: bonus.typeId,
                                  attrs: {
                                    label:
                                      "[" +
                                      bonus.typeId +
                                      "] " +
                                      bonus.typeName,
                                    value: bonus.typeId,
                                  },
                                })
                              }),
                              1
                            ),
                            _vm._v(" "),
                            _c("el-input-number", {
                              staticStyle: {
                                "margin-left": "10px",
                                width: "130px",
                              },
                              attrs: { min: 1, size: "small" },
                              model: {
                                value: item.num,
                                callback: function ($$v) {
                                  _vm.$set(item, "num", $$v)
                                },
                                expression: "item.num",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "reward-num-label" }, [
                              _vm._v("张"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                staticStyle: {
                                  color: "#F56C6C",
                                  "margin-left": "10px",
                                },
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeRewardItem(
                                      _vm.rewardErrorItems,
                                      index
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                  删除\n                "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text", icon: "el-icon-plus" },
                          on: {
                            click: function ($event) {
                              return _vm.addRewardItem(_vm.rewardErrorItems)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                添加猜错奖励\n              "
                          ),
                        ]
                      ),
                    ],
                    2
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-col form-col-side" }, [
              _c("div", { staticClass: "section-card" }, [
                _c("div", { staticClass: "section-card-header" }, [
                  _vm._v("\n            口令设置\n          "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "section-card-body" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "口令", prop: "pwd" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请输入口令" },
                          model: {
                            value: _vm.form.pwd,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "pwd", $$v)
                            },
                            expression: "form.pwd",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "提示文案", prop: "tips" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "textarea",
                            rows: 3,
                            placeholder: "请输入提示文案",
                          },
                          model: {
                            value: _vm.form.tips,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "tips", $$v)
                            },
                            expression: "form.tips",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "section-card" }, [
                _c("div", { staticClass: "section-card-header" }, [
                  _vm._v("\n            资格限制\n          "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "section-card-body" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "会员级别" } },
                      [
                        _c(
                          "el-checkbox",
                          {
                            attrs: {
                              indeterminate: _vm.isLevelIndeterminate,
                              value: _vm.isLevelAllChecked,
                            },
                            on: { change: _vm.handleCheckAllLevel },
                          },
                          [_vm._v("\n                全选\n              ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-checkbox-group",
                          {
                            model: {
                              value: _vm.userLevelsChecked,
                              callback: function ($$v) {
                                _vm.userLevelsChecked = $$v
                              },
                              expression: "userLevelsChecked",
                            },
                          },
                          _vm._l(_vm.gradeOptions, function (grade) {
                            return _c(
                              "el-checkbox",
                              { key: grade.id, attrs: { label: grade.id } },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(grade.name) +
                                    "\n                "
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-hint-block" }, [
                          _vm._v(
                            "\n                不勾选 = 不限等级\n              "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "用户标签" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              multiple: "",
                              filterable: "",
                              clearable: "",
                              placeholder: "不选择 = 不限标签",
                            },
                            model: {
                              value: _vm.userTagsChecked,
                              callback: function ($$v) {
                                _vm.userTagsChecked = $$v
                              },
                              expression: "userTagsChecked",
                            },
                          },
                          _vm._l(_vm.tagOptions, function (tag) {
                            return _c("el-option", {
                              key: tag.id,
                              attrs: { label: tag.name, value: tag.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "企微用户" } },
                      [
                        _c("el-switch", {
                          attrs: {
                            "active-value": 1,
                            "inactive-value": 0,
                            "active-text": "仅企微",
                            "inactive-text": "不限",
                          },
                          model: {
                            value: _vm.form.userWw,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "userWw", $$v)
                            },
                            expression: "form.userWw",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "参与地区" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              multiple: "",
                              filterable: "",
                              clearable: "",
                              placeholder: "请选择参与地区",
                            },
                            on: { change: _vm.handleZoneChange },
                            model: {
                              value: _vm.zoneChecked,
                              callback: function ($$v) {
                                _vm.zoneChecked = $$v
                              },
                              expression: "zoneChecked",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "全国", value: 0 },
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.cityOptions, function (city) {
                              return _c("el-option", {
                                key: city.regionId,
                                attrs: {
                                  label: city.regionName,
                                  value: city.regionId,
                                  disabled: _vm.isNationwide,
                                },
                              })
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "section-card" }, [
                _c("div", { staticClass: "section-card-header" }, [
                  _vm._v("\n            库存与次数\n          "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "section-card-body" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "猜对上限", prop: "allStock" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "200px" },
                          attrs: {
                            min: _vm.isEdit ? _vm.originalAllStock || 0 : 0,
                          },
                          model: {
                            value: _vm.form.allStock,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "allStock", $$v)
                            },
                            expression: "form.allStock",
                          },
                        }),
                        _vm._v(" "),
                        _vm.isEdit && _vm.stockInfo
                          ? _c("div", { staticClass: "stock-note" }, [
                              _vm._v(
                                "\n                库存(剩余/总): " +
                                  _vm._s(_vm.stockInfo.remaining) +
                                  "/" +
                                  _vm._s(_vm.stockInfo.total) +
                                  "\n              "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isEdit
                          ? _c("div", { staticClass: "form-hint-block" }, [
                              _vm._v(
                                "\n                当前上限：" +
                                  _vm._s(_vm.originalAllStock) +
                                  "，只能增加不能减少\n              "
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "每日发放上限", prop: "dayStock" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "200px" },
                          attrs: { min: 0 },
                          model: {
                            value: _vm.form.dayStock,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "dayStock", $$v)
                            },
                            expression: "form.dayStock",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "form-hint" }, [
                          _vm._v("0=不限"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "每人总次数", prop: "allJoin" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "200px" },
                          attrs: { min: 0 },
                          model: {
                            value: _vm.form.allJoin,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "allJoin", $$v)
                            },
                            expression: "form.allJoin",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "form-hint" }, [
                          _vm._v("0=不限"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "每人每日次数", prop: "dayJoin" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "200px" },
                          attrs: { min: 0 },
                          model: {
                            value: _vm.form.dayJoin,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "dayJoin", $$v)
                            },
                            expression: "form.dayJoin",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "form-hint" }, [
                          _vm._v("0=不限"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "猜错上限", prop: "allStockError" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "200px" },
                          attrs: {
                            min: _vm.isEdit
                              ? _vm.originalAllStockError || 0
                              : 0,
                          },
                          model: {
                            value: _vm.form.allStockError,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "allStockError", $$v)
                            },
                            expression: "form.allStockError",
                          },
                        }),
                        _vm._v(" "),
                        _vm.isEdit && _vm.stockInfo
                          ? _c("div", { staticClass: "stock-note" }, [
                              _vm._v(
                                "\n                库存(剩余/总): " +
                                  _vm._s(_vm.stockInfo.errorRemaining) +
                                  "/" +
                                  _vm._s(_vm.stockInfo.errorTotal) +
                                  "\n              "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isEdit
                          ? _c("div", { staticClass: "form-hint-block" }, [
                              _vm._v(
                                "\n                当前上限：" +
                                  _vm._s(_vm.originalAllStockError) +
                                  "，只能增加不能减少\n              "
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "猜错领奖次数", prop: "drawError" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "200px" },
                          attrs: { min: 0 },
                          model: {
                            value: _vm.form.drawError,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "drawError", $$v)
                            },
                            expression: "form.drawError",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "form-hint" }, [
                          _vm._v("每人猜错可领安慰奖次数，0=不限"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "section-card" }, [
                _c("div", { staticClass: "section-card-header" }, [
                  _vm._v("\n            跳转配置\n          "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "section-card-body" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "跳转类型", prop: "jumpType" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            on: { change: _vm.handleJumpTypeChange },
                            model: {
                              value: _vm.form.jumpType,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "jumpType", $$v)
                              },
                              expression: "form.jumpType",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v(
                                "\n                  无\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v(
                                "\n                  外部链接\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 2 } }, [
                              _vm._v(
                                "\n                  系统链接\n                "
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.form.jumpType === 1
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "跳转链接", prop: "linkurl" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { placeholder: "请输入跳转链接" },
                              model: {
                                value: _vm.form.linkurl,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "linkurl", $$v)
                                },
                                expression: "form.linkurl",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.form.jumpType === 2
                      ? [
                          _c(
                            "el-form-item",
                            { attrs: { label: "跳转页面", prop: "linkurl" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    filterable: "",
                                    clearable: "",
                                    placeholder: "请选择跳转页面",
                                  },
                                  model: {
                                    value: _vm.form.linkurl,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "linkurl", $$v)
                                    },
                                    expression: "form.linkurl",
                                  },
                                },
                                _vm._l(_vm.pageOptions, function (page) {
                                  return _c("el-option", {
                                    key: page.pageUrl,
                                    attrs: {
                                      label: page.pageName,
                                      value: page.pageUrl,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "资源ID", prop: "linkid" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "100%" },
                                attrs: { placeholder: "请输入资源ID" },
                                model: {
                                  value: _vm.form.linkid,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "linkid", $$v)
                                  },
                                  expression: "form.linkid",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-actions" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v("\n        保存\n      ")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.handleCancel } }, [
                _vm._v("\n        取消\n      "),
              ]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }